import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

type Tone = 'neutral' | 'ok' | 'warn' | 'bad' | 'info' | 'brand';

interface Props extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
  dot?: boolean;
}

const tones: Record<Tone, string> = {
  neutral: 'bg-slate-100 text-slate-700',
  ok:      'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200',
  warn:    'bg-amber-50 text-amber-700 ring-1 ring-amber-200',
  bad:     'bg-red-50 text-red-700 ring-1 ring-red-200',
  info:    'bg-sky-50 text-sky-700 ring-1 ring-sky-200',
  brand:   'bg-ink text-signal',
};

const dots: Record<Tone, string> = {
  neutral: 'bg-slate-400',
  ok:      'bg-emerald-500',
  warn:    'bg-amber-500',
  bad:     'bg-red-500',
  info:    'bg-sky-500',
  brand:   'bg-signal',
};

export function Badge({ tone = 'neutral', dot, className, children, ...rest }: Props) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-semibold',
        tones[tone],
        className,
      )}
      {...rest}
    >
      {dot && <span className={cn('w-1.5 h-1.5 rounded-full', dots[tone])} />}
      {children}
    </span>
  );
}
